import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'src/redux/types';
import { PlatformVersionItem } from '../types';

export const usePlatformVersionsList = (): [
  PlatformVersionItem[],
  boolean | undefined,
] => {
  const { data, loading } = useSelector(
    (state: State) => state.platformVersions || {}
  );

  return [
    useMemo(() => data || [], [data]),
    useMemo(() => loading, [loading]),
  ];
};
